// The auth context's contract, split out from the provider component so that
// AuthContext.tsx exports a component and nothing else — Vite's Fast Refresh
// only preserves state across edits for modules whose exports are all
// components. The provider is in AuthContext.tsx, the hook in use-auth.ts.
import { createContext } from 'react';
import type { Permission } from '../lib/permissions';

export type AppRole = 'Admin' | 'SafetyNet';

export interface AuthState {
  status: 'loading' | 'signed-out' | 'signed-in' | 'unauthorized';
  email: string | null;
  role: AppRole | null;
  permissions: Set<Permission>;
  name: string | null;
  picture: string | null;
  errorMessage: string | null;
}

export interface AuthContextValue extends AuthState {
  signIn: () => Promise<void>;
  signOut: () => Promise<void>;
  refresh: () => Promise<void>;
  can: (permission: Permission) => boolean;
}

export const initialAuthState: AuthState = {
  status: 'loading',
  email: null,
  role: null,
  permissions: new Set(),
  name: null,
  picture: null,
  errorMessage: null,
};

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
